import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {SupportUsers} from '../models/support-users';

export const supportUsersActionTypes = {
  LOAD: type('[SupportUsers] Load'),
  LOAD_SUCCESS: type('[SupportUsers] Load Success'),
  LOAD_FAIL: type('[SupportUsers] Load Fail'),
  UPDATE: type('[SupportUsers] Update')
};

export class LoadSupportUsersAction implements Action {
  readonly type = supportUsersActionTypes.LOAD;
  constructor() {}
}

export class LoadSupportUsersSuccessAction implements Action {
  readonly type = supportUsersActionTypes.LOAD_SUCCESS;
  constructor(public payload?: SupportUsers[]) {}
}

export class LoadSupportUsersFailAction implements Action {
  readonly type = supportUsersActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class UpdateSupportUsersSuccessAction implements Action {
  readonly type = supportUsersActionTypes.UPDATE;
  constructor(public payload?: SupportUsers[]) {}
}
